import { array, constant, either, maybe, object, string } from 'decoders';
import { Entity } from '.';
import { Asset, assetDecoder } from './asset';
import { Decodify, isodate } from './decoders';
import { User, userDecoder } from './user';

export type DocumentType = 'receipt' | 'warranty';

export interface Attachment {
  name: string;
}

export interface Document extends Entity {
  name: string;
  created_by: User;
  type: DocumentType;
  created_at: Date;
  assets?: Asset[];
  // TODO: Will need to discuss how attachments will work on the backend
  attachments: Attachment[];
}

export const documentTypeDecoder = either(
  constant('receipt' as DocumentType),
  constant('warranty' as DocumentType)
);

const attachmentDecoder = object<Decodify<Attachment>>({
  name: string,
});

export const documentDecoder = object<Decodify<Document>>({
  id: string,
  name: string,
  created_at: isodate,
  created_by: userDecoder,
  type: documentTypeDecoder,
  assets: maybe(array(assetDecoder)),
  attachments: array(attachmentDecoder),
});
